import { jsx as e, jsxs as i } from "react/jsx-runtime";
function a(l) {
  return /* @__PURE__ */ e("svg", { height: "1em", viewBox: "0 0 20 20", width: "1em", ...l, children: /* @__PURE__ */ i("g", { fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ e("circle", { cx: 10, cy: 10, fill: "currentColor", r: 10 }),
    /* @__PURE__ */ e(
      "path",
      {
        d: "M16.197 5.68a1.05 1.05 0 00-1.44.025l-6.453 6.51-2.207-2.206a.953.953 0 00-1.384.036l-.033.036a1.039 1.039 0 00.03 1.432l2.883 2.797a1.02 1.02 0 001.42-.014l7.252-7.2a.95.95 0 00-.032-1.383l-.036-.033z",
        fill: l.fill ? l.fill : "#00182E"
      }
    )
  ] }) });
}
export {
  a as default
};
